import { useState, useEffect } from 'react';

interface Versions {
    authWeb: string;
    hubApi: string;
    hubWeb: string;
    shellApi: string;
}

export function VersionDisplay() {
    const [versions, setVersions] = useState<Versions | null>(null);

    useEffect(() => {
        fetch('/versions.json')
            .then((res) => res.json())
            .then((data) => setVersions(data))
            .catch((err) => console.error('Failed to load versions:', err));
    }, []);

    if (!versions) {
        return null;
    }

    return (
        <div className="mt-8 pt-6 border-t border-grey-200">
            <div className="flex justify-end">
                <div className="text-xs text-grey-500 space-y-1">
                    <div className="font-medium text-grey-600 mb-2">App Versions</div>
                    <div>Hub API: v{versions.hubApi}</div>
                    <div>Hub Web: v{versions.hubWeb}</div>
                </div>
            </div>
        </div>
    );
}
